// Vue setup imports
import Vue from 'vue';
import App from '@/App.vue'
import router from '@/router/index.js';
import store from '@/store/index.js';

import api from '@/api/index.js';
//import api from '@/api/fake'

// UI library imports
import VueFlatPickr from 'vue-flatpickr-component';

// Global UI Managers
import LoadingManager from '@/modules/overlays/loading/loading-manager.js';
import ModalManager from '@/modules/overlays/modal/modal-manager.js';
import MessageManager from '@/modules/overlays/message/message-manager.js';
import Validator from '@/utils/fieldValidator.js';
import LocalStore from '@/utils/localStore.js';
// Custom UI imports
import MHIHeader from '@/components/MHIHeader.vue';
import MHIFooter from '@/components/MHIFooter.vue';
import MHISessionTimeout from '@/components/MHISessionTimeout.vue';
// Custom input components
import InputComponents from '@/components/input/InputComponentMixin.js';
import { BootstrapVue } from 'bootstrap-vue';
import { Grid } from '@progress/kendo-vue-grid'
// Library inits
Vue.use(VueFlatPickr);

Vue.use(BootstrapVue)

// Register global layout components
Vue.component('mhi-header', MHIHeader);
Vue.component('mhi-footer', MHIFooter);
Vue.component('mhi-session-timeout', MHISessionTimeout);
Vue.component('KendoGrid', Grid);

// Register global input components
Vue.mixin(InputComponents);

// Set up prototypes
Vue.prototype.$loader = LoadingManager;
Vue.prototype.$modal = ModalManager;
Vue.prototype.$message = MessageManager;
Vue.prototype.$validator = Validator;
Vue.prototype.$localStore = LocalStore;
Vue.prototype.$window = window;
Vue.use(api);

// Init vue
const vue = new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app');

export default vue;